"use strict";

require("core-js/modules/es.symbol.description");

const SymbolStop = Symbol.for('stop');
module.exports = stop;

function stop(value) {
  return {
    [SymbolStop]: true,
    value
  };
}